export const getValidGroupName = (groupName: unknown, reserveName: string) => {
	if (typeof groupName !== 'string') {
		return reserveName
	}

	if (groupName === 'undefined' || groupName === 'null') {
		return reserveName
	}

	return groupName
}
